export function createSingleRunInitializer(callback: () => void) {
  let hasRun = false;

  return () => {
    if (hasRun) return;
    hasRun = true;
    callback();
  };
}
